import React from "react";
import { KolButton } from "@public-ui/react";
import { IconsPropType } from "@public-ui/components";

interface IButtonSecondaryProps {
    /**
     * Label of button
     */
    label: string;
    className?: string;
    /**
     * Callback function for OnClick-Event
     */
    onClick?: (event: Event) => void;
    /**
     * Class string or object for optional icons
     */
    icons?: IconsPropType;
    /**
     * Set to `true` to disable button
     */
    disabled?: boolean;
}

export const ButtonSecondary: React.FC<IButtonSecondaryProps> = ({ label, className, onClick, icons, disabled }) => {
    return (
        <KolButton
            className={className}
            _label={label}
            _variant="secondary"
            _icons={icons}
            _on={{ onClick }}
            _disabled={disabled}
        />
    );
};
